'use client';

import { useContext } from 'react';
import { DevDashContext } from '../components/DevDashProvider';
import type { DevDashContextValue } from '../types';

/**
 * Hook to access DevDash context
 *
 * Returns the DevDash context value, or a no-op version if used outside
 * the provider or when DevDash is disabled.
 */
export function useDevDash(): DevDashContextValue {
  const context = useContext(DevDashContext);

  if (!context) {
    // Return a no-op version when used outside provider or when disabled
    // biome-ignore lint/suspicious/noEmptyBlockStatements: Intentional no-op functions for disabled state
    return {
      environment: 'unknown',
      isEnabled: false,
      logout: () => {},
      resetToDefaults: () => {},
      setActiveTab: () => {},
      setIsOpen: () => {},
      setThemeMode: () => {},
      state: {
        activeTab: 'status',
        isOpen: false,
        themeMode: 'dark',
      },
      toggleOpen: () => {},
    };
  }

  return context;
}
